let Vue = require('vue');
let EditInterfaceText = require('./components/EditInterfaceText').default;

/**
 * Initialize overridable interface text popovers, which are Vue components.
 *
 * Notice:
 * If the component had a Vue parent in DOM, it has been already initialized.
 * If the component didn't have Vue parent, instantiate them now.
 */
module.exports = {
  init: function() {
    // Timeout is needed to avoid trying to initialize the component twice - first in parent component,
    // second as a root component.
    setTimeout(() => {
      Array.from(document.getElementsByTagName('edit-interface-text')).forEach(
        editInterfaceText => {
          new Vue({
            el: editInterfaceText,
            components: {
              'edit-interface-text': EditInterfaceText
            }
          });
        }
      );
    }, 100);
  }
};
